import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-controle-documentos',
  templateUrl: './controle-documentos.component.html',
  styleUrls: ['./controle-documentos.component.css']
})
export class ControleDocumentosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
